// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.changePassword-container {
  min-height: calc(100vh - 50px);
  background-color: #f3f3ea;
}

.form-field-space {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/change-password/change-password.component.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;EAEA,yBAAA;AADF;;AAKA;EACE,gBAAA;AAFF","sourcesContent":["\r\n.changePassword-container{\r\n  min-height: calc(100vh - 50px);\r\n //  background-color: #fbf9ec;\r\n  background-color: #f3f3ea;\r\n}\r\n\r\n\r\n.form-field-space{\r\n  margin-top: 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
